<div #printComponent class="print-options">
  <div class="input-wrap mt-2 print-select">
    <div class="input-wrap print-select-data">
      <mat-select #printOptions
                  (valueChange)="onChange($event);"
                  class="text-left"
                  placeholder="Download">
        <mat-option *ngFor="let option of options" [value]="option.id">
          <span class="print-icon">{{option.name}}
            <i class="material-icons dropdown-icon-inner">{{option.icon}}</i></span>
        </mat-option>
      </mat-select>
      <span class="print-icon"><i
        class="material-icons">{{printOption == 1 ? 'get_app' : 'print'}}</i></span>
    </div>
  </div>
</div>


<!-- Open print modal iframe -->
<!--<iframe id='print-iframe' frameborder="0" style="visibility:hidden;"></iframe>-->
